// tslint:disable
/* MACLE TypeScript 17/07/2025 17:31:47 */
import { ArrayList } from 'maf-web';

export class BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseVO";
}


export class BaseData extends BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseData";
}


export class DataLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLojaAPP";
  fantasia: string = "";
  cidade: string = "";
  bairro: string = "";
  cnpj: string = "";
  numero: string = "";
  logradouro: string = "";
  telefone: number = 0;
  UF: string = "";
  CEP: number = 0;
}


export class DataServiceResponse extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataServiceResponse";
  pk: BaseData = new BaseData();
  mensagem: string = "";
}


export class DataErrorResp extends DataServiceResponse {
  readonly jclass: string = "com.sollus.vo.DataErrorResp";
  stackTrace: string[] = [];
  codigo: number = 0;
  errorClass: string = "";
}


export class DataAmbiente extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataAmbiente";
  protocolo: string = "";
  nomeServidor: string = "";
  ipServidor: string = "";
  contexto: string = "";
  porta: string = "";
  basePath: string = "";
}


export class BaseDataDisplay extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataDisplay";
  value: string = "";
  display: string = "";
}


export class ETipoLicenca {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoLicenca = new ETipoLicenca("0");
  get NONE() {
    return ETipoLicenca.NONE;
  }

  static readonly FULL: ETipoLicenca = new ETipoLicenca("1");
  get FULL() {
    return ETipoLicenca.FULL;
  }

  static readonly LIGHT: ETipoLicenca = new ETipoLicenca("2");
  get LIGHT() {
    return ETipoLicenca.LIGHT;
  }

  static readonly TRIAL: ETipoLicenca = new ETipoLicenca("3");
  get TRIAL() {
    return ETipoLicenca.TRIAL;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Informe";
      case "1": return "Controle FULL";
      case "2": return "Controle LIGHT";
      case "3": return "Trial";
      default: return "";
    }
  }

  public equals(arg: ETipoLicenca): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoLicenca[] = [this.NONE,this.FULL,this.LIGHT,this.TRIAL];
}


export class PKStr extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKStr";
  codigo: string = "";

  constructor()
  constructor(codigo: string)
  constructor(codigo?: string) {
    super();
    this.codigo = codigo || "";
  }

  public getPK(): PKStr {
    return new PKStr(this.codigo);
  }

  public equals(arg: PKStr): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class EAmbienteVitrine {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EAmbienteVitrine = new EAmbienteVitrine("0");
  get NONE() {
    return EAmbienteVitrine.NONE;
  }

  static readonly DEDICADO: EAmbienteVitrine = new EAmbienteVitrine("1");
  get DEDICADO() {
    return EAmbienteVitrine.DEDICADO;
  }

  static readonly COMPARTILHADO: EAmbienteVitrine = new EAmbienteVitrine("2");
  get COMPARTILHADO() {
    return EAmbienteVitrine.COMPARTILHADO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Dedicado";
      case "2": return "Compartilhado";
      default: return "";
    }
  }

  public equals(arg: EAmbienteVitrine): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EAmbienteVitrine[] = [this.NONE,this.DEDICADO,this.COMPARTILHADO];
}


export class BaseDataParamSistema extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataParamSistema";
  appImgPath: string = "";
  appBasePath: string = "";
  idBase: number = 0;
  versaoBase: number = 0;
  numRecInPage: number = 0;
  imgContextName: string = "";
}


export class PKFuncionario extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKFuncionario";
  codEmpresa: number = 0;
  codFuncionario: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): PKFuncionario {
    return new PKFuncionario(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: PKFuncionario): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codFuncionario === this.codFuncionario)
    ;
  }
}


export class EFilterBool {

  constructor(value?: string) {
    this.value = value || "''";
  }

  static readonly NONE: EFilterBool = new EFilterBool("''");
  get NONE() {
    return EFilterBool.NONE;
  }

  static readonly SIM: EFilterBool = new EFilterBool("'S'");
  get SIM() {
    return EFilterBool.SIM;
  }

  static readonly NAO: EFilterBool = new EFilterBool("'N'");
  get NAO() {
    return EFilterBool.NAO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "''": return "Todos";
      case "'S'": return "Sim";
      case "'N'": return "N&atilde;o";
      default: return "";
    }
  }

  public equals(arg: EFilterBool): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EFilterBool[] = [this.NONE,this.SIM,this.NAO];
}


export class FilterLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.FilterLOG";
  entidade: number = 0;
  acao: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  repl: EFilterBool = new EFilterBool();
  dataFim: string = "";
  dataIni: string = "";
}


export class PKLong extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKLong";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PKLong {
    return new PKLong(this.codigo);
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class JsonObject {
  readonly jclass: string = "com.sollus.json.JsonObject";
}


export class EPeriodo {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly HOJE: EPeriodo = new EPeriodo("0");
  get HOJE() {
    return EPeriodo.HOJE;
  }

  static readonly ONTEM: EPeriodo = new EPeriodo("4");
  get ONTEM() {
    return EPeriodo.ONTEM;
  }

  static readonly AMANHA: EPeriodo = new EPeriodo("10");
  get AMANHA() {
    return EPeriodo.AMANHA;
  }

  static readonly SEMANA_ATUAL: EPeriodo = new EPeriodo("1");
  get SEMANA_ATUAL() {
    return EPeriodo.SEMANA_ATUAL;
  }

  static readonly SEMANA_ANTERIOR: EPeriodo = new EPeriodo("5");
  get SEMANA_ANTERIOR() {
    return EPeriodo.SEMANA_ANTERIOR;
  }

  static readonly SEMANA_PROXIMA: EPeriodo = new EPeriodo("11");
  get SEMANA_PROXIMA() {
    return EPeriodo.SEMANA_PROXIMA;
  }

  static readonly MES_ATUAL: EPeriodo = new EPeriodo("2");
  get MES_ATUAL() {
    return EPeriodo.MES_ATUAL;
  }

  static readonly MES_ANTERIOR: EPeriodo = new EPeriodo("6");
  get MES_ANTERIOR() {
    return EPeriodo.MES_ANTERIOR;
  }

  static readonly MES_PROXIMO: EPeriodo = new EPeriodo("12");
  get MES_PROXIMO() {
    return EPeriodo.MES_PROXIMO;
  }

  static readonly ULTIMOS_TRES_MESES: EPeriodo = new EPeriodo("8");
  get ULTIMOS_TRES_MESES() {
    return EPeriodo.ULTIMOS_TRES_MESES;
  }

  static readonly ULTIMOS_DOZE_MESES: EPeriodo = new EPeriodo("18");
  get ULTIMOS_DOZE_MESES() {
    return EPeriodo.ULTIMOS_DOZE_MESES;
  }

  static readonly PROXIMOS_TRES_MESES: EPeriodo = new EPeriodo("13");
  get PROXIMOS_TRES_MESES() {
    return EPeriodo.PROXIMOS_TRES_MESES;
  }

  static readonly SEMESTRE_ATUAL: EPeriodo = new EPeriodo("14");
  get SEMESTRE_ATUAL() {
    return EPeriodo.SEMESTRE_ATUAL;
  }

  static readonly SEMESTRE_ANTERIOR: EPeriodo = new EPeriodo("15");
  get SEMESTRE_ANTERIOR() {
    return EPeriodo.SEMESTRE_ANTERIOR;
  }

  static readonly SEMESTRE_PROXIMO: EPeriodo = new EPeriodo("16");
  get SEMESTRE_PROXIMO() {
    return EPeriodo.SEMESTRE_PROXIMO;
  }

  static readonly ANO_ATUAL: EPeriodo = new EPeriodo("3");
  get ANO_ATUAL() {
    return EPeriodo.ANO_ATUAL;
  }

  static readonly ANO_ANTERIOR: EPeriodo = new EPeriodo("7");
  get ANO_ANTERIOR() {
    return EPeriodo.ANO_ANTERIOR;
  }

  static readonly ANO_PROXIMO: EPeriodo = new EPeriodo("17");
  get ANO_PROXIMO() {
    return EPeriodo.ANO_PROXIMO;
  }

  static readonly PERSONALIZADO: EPeriodo = new EPeriodo("9");
  get PERSONALIZADO() {
    return EPeriodo.PERSONALIZADO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Hoje";
      case "4": return "Ontem";
      case "10": return "Amanh&amp;atilde;";
      case "1": return "Semana atual";
      case "5": return "Semana anterior";
      case "11": return "Pr&amp;oacute;xima semana";
      case "2": return "M&amp;ecirc;s atual";
      case "6": return "M&amp;ecirc;s anterior";
      case "12": return "Pr&amp;oacute;ximo m&amp;ecirc;s";
      case "8": return "&amp;Uacute;ltimos tr&amp;ecirc;s meses";
      case "18": return "&amp;Uacute;ltimos doze meses";
      case "13": return "Pr&amp;oacute;ximos tr&amp;ecirc;s meses";
      case "14": return "Semestre atual";
      case "15": return "Semestre anterior";
      case "16": return "Pr&amp;oacute;ximo semestre";
      case "3": return "Ano atual";
      case "7": return "Ano anterior";
      case "17": return "Pr&amp;oacute;ximo ano";
      case "9": return "Personalizado";
      default: return "";
    }
  }

  public equals(arg: EPeriodo): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EPeriodo[] = [this.HOJE,this.ONTEM,this.AMANHA,this.SEMANA_ATUAL,this.SEMANA_ANTERIOR,this.SEMANA_PROXIMA,this.MES_ATUAL,this.MES_ANTERIOR,this.MES_PROXIMO,this.ULTIMOS_TRES_MESES,this.ULTIMOS_DOZE_MESES,this.PROXIMOS_TRES_MESES,this.SEMESTRE_ATUAL,this.SEMESTRE_ANTERIOR,this.SEMESTRE_PROXIMO,this.ANO_ATUAL,this.ANO_ANTERIOR,this.ANO_PROXIMO,this.PERSONALIZADO];
}


export class ETipoVitrine {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoVitrine = new ETipoVitrine("0");
  get NONE() {
    return ETipoVitrine.NONE;
  }

  static readonly PRIVADA: ETipoVitrine = new ETipoVitrine("1");
  get PRIVADA() {
    return ETipoVitrine.PRIVADA;
  }

  static readonly PUBLICA: ETipoVitrine = new ETipoVitrine("2");
  get PUBLICA() {
    return ETipoVitrine.PUBLICA;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Privada";
      case "2": return "P&uacute;blica";
      default: return "";
    }
  }

  public equals(arg: ETipoVitrine): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoVitrine[] = [this.NONE,this.PRIVADA,this.PUBLICA];
}


export class ETipoVendaNFe {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoVendaNFe = new ETipoVendaNFe("0");
  get NONE() {
    return ETipoVendaNFe.NONE;
  }

  static readonly PRESENCIAL: ETipoVendaNFe = new ETipoVendaNFe("1");
  get PRESENCIAL() {
    return ETipoVendaNFe.PRESENCIAL;
  }

  static readonly INTERNET: ETipoVendaNFe = new ETipoVendaNFe("2");
  get INTERNET() {
    return ETipoVendaNFe.INTERNET;
  }

  static readonly OUTROS: ETipoVendaNFe = new ETipoVendaNFe("3");
  get OUTROS() {
    return ETipoVendaNFe.OUTROS;
  }

  static readonly NFC_DELIVERY: ETipoVendaNFe = new ETipoVendaNFe("4");
  get NFC_DELIVERY() {
    return ETipoVendaNFe.NFC_DELIVERY;
  }

  static readonly PRESENCIAL_FORA_ESTABELECIMENTO: ETipoVendaNFe = new ETipoVendaNFe("5");
  get PRESENCIAL_FORA_ESTABELECIMENTO() {
    return ETipoVendaNFe.PRESENCIAL_FORA_ESTABELECIMENTO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Presencial";
      case "2": return "Internet";
      case "3": return "Outros";
      case "4": return "NFCe Delivery";
      case "5": return "Presencial fora do estabelecimento";
      default: return "";
    }
  }

  public equals(arg: ETipoVendaNFe): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoVendaNFe[] = [this.NONE,this.PRESENCIAL,this.INTERNET,this.OUTROS,this.NFC_DELIVERY,this.PRESENCIAL_FORA_ESTABELECIMENTO];
}


export class ETipoFone {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoFone = new ETipoFone("0");
  get NONE() {
    return ETipoFone.NONE;
  }

  static readonly CELULAR: ETipoFone = new ETipoFone("1");
  get CELULAR() {
    return ETipoFone.CELULAR;
  }

  static readonly CASA: ETipoFone = new ETipoFone("2");
  get CASA() {
    return ETipoFone.CASA;
  }

  static readonly TRABALHO: ETipoFone = new ETipoFone("3");
  get TRABALHO() {
    return ETipoFone.TRABALHO;
  }

  static readonly OUTRO: ETipoFone = new ETipoFone("99");
  get OUTRO() {
    return ETipoFone.OUTRO;
  }

  static readonly ESTRANGEIRO: ETipoFone = new ETipoFone("100");
  get ESTRANGEIRO() {
    return ETipoFone.ESTRANGEIRO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Celular";
      case "2": return "Casa";
      case "3": return "Trabalho";
      case "99": return "Outros";
      case "100": return "Estrangeiro";
      default: return "";
    }
  }

  public equals(arg: ETipoFone): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoFone[] = [this.NONE,this.CELULAR,this.CASA,this.TRABALHO,this.OUTRO,this.ESTRANGEIRO];
}


export class DataListaLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaLojaAPP";
  listLoja: ArrayList<DataLojaAPP> = new ArrayList<DataLojaAPP>(DataLojaAPP);
}


export class PeriodoMes extends BaseData {
  readonly jclass: string = "com.sollus.vo.PeriodoMes";
  meses: number = 0;
}


export class DataEndereco extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataEndereco";
  cidade: string = "";
  bairro: string = "";
  endereco: string = "";
  codCEP: number = 0;
  codUF: string = "";
  codPais: number = 0;
  numero: string = "";
  complemento: string = "";
}


export class DataClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataClienteMacleAPP";
  fantasia: string = "";
  endereco: DataEndereco = new DataEndereco();
  servidorConsulta: string = "";
  codClienteMacle: number = 0;
}


export class ETipoFrete {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoFrete = new ETipoFrete("0");
  get NONE() {
    return ETipoFrete.NONE;
  }

  static readonly SEDEX: ETipoFrete = new ETipoFrete("1");
  get SEDEX() {
    return ETipoFrete.SEDEX;
  }

  static readonly PAC: ETipoFrete = new ETipoFrete("2");
  get PAC() {
    return ETipoFrete.PAC;
  }

  static readonly ENVIO_FLEX_ML: ETipoFrete = new ETipoFrete("3");
  get ENVIO_FLEX_ML() {
    return ETipoFrete.ENVIO_FLEX_ML;
  }

  static readonly TRANSPORTADORA: ETipoFrete = new ETipoFrete("4");
  get TRANSPORTADORA() {
    return ETipoFrete.TRANSPORTADORA;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Sedex";
      case "2": return "Encomenda PAC";
      case "3": return "Envio Flex";
      case "4": return "Transporadora";
      default: return "";
    }
  }

  public equals(arg: ETipoFrete): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoFrete[] = [this.NONE,this.SEDEX,this.PAC,this.ENVIO_FLEX_ML,this.TRANSPORTADORA];
}


export class PKable {
  readonly jclass: string = "com.sollus.vo.PKable";
}


export class DataListaClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaClienteMacleAPP";
  listCli: ArrayList<DataClienteMacleAPP> = new ArrayList<DataClienteMacleAPP>(DataClienteMacleAPP);
}


export class EUF {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EUF = new EUF("0");
  get NONE() {
    return EUF.NONE;
  }

  static readonly AC: EUF = new EUF("1");
  get AC() {
    return EUF.AC;
  }

  static readonly AL: EUF = new EUF("2");
  get AL() {
    return EUF.AL;
  }

  static readonly AM: EUF = new EUF("3");
  get AM() {
    return EUF.AM;
  }

  static readonly AP: EUF = new EUF("4");
  get AP() {
    return EUF.AP;
  }

  static readonly BA: EUF = new EUF("5");
  get BA() {
    return EUF.BA;
  }

  static readonly CE: EUF = new EUF("6");
  get CE() {
    return EUF.CE;
  }

  static readonly DF: EUF = new EUF("7");
  get DF() {
    return EUF.DF;
  }

  static readonly ES: EUF = new EUF("8");
  get ES() {
    return EUF.ES;
  }

  static readonly GO: EUF = new EUF("9");
  get GO() {
    return EUF.GO;
  }

  static readonly MA: EUF = new EUF("10");
  get MA() {
    return EUF.MA;
  }

  static readonly MG: EUF = new EUF("11");
  get MG() {
    return EUF.MG;
  }

  static readonly MS: EUF = new EUF("12");
  get MS() {
    return EUF.MS;
  }

  static readonly MT: EUF = new EUF("13");
  get MT() {
    return EUF.MT;
  }

  static readonly PA: EUF = new EUF("14");
  get PA() {
    return EUF.PA;
  }

  static readonly PB: EUF = new EUF("15");
  get PB() {
    return EUF.PB;
  }

  static readonly PE: EUF = new EUF("16");
  get PE() {
    return EUF.PE;
  }

  static readonly PI: EUF = new EUF("17");
  get PI() {
    return EUF.PI;
  }

  static readonly PR: EUF = new EUF("18");
  get PR() {
    return EUF.PR;
  }

  static readonly RJ: EUF = new EUF("19");
  get RJ() {
    return EUF.RJ;
  }

  static readonly RN: EUF = new EUF("20");
  get RN() {
    return EUF.RN;
  }

  static readonly RO: EUF = new EUF("21");
  get RO() {
    return EUF.RO;
  }

  static readonly RR: EUF = new EUF("22");
  get RR() {
    return EUF.RR;
  }

  static readonly RS: EUF = new EUF("23");
  get RS() {
    return EUF.RS;
  }

  static readonly SC: EUF = new EUF("24");
  get SC() {
    return EUF.SC;
  }

  static readonly SE: EUF = new EUF("25");
  get SE() {
    return EUF.SE;
  }

  static readonly SP: EUF = new EUF("26");
  get SP() {
    return EUF.SP;
  }

  static readonly TO: EUF = new EUF("27");
  get TO() {
    return EUF.TO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "AC - Acre";
      case "2": return "AL - Alagoas";
      case "3": return "AM - Amazonas";
      case "4": return "AP - Amap&aacute;";
      case "5": return "BA - Bahia";
      case "6": return "CE - Cear&aacute;";
      case "7": return "DF - Distrito Federal";
      case "8": return "ES - Esp&iacute;rito Santo";
      case "9": return "GO - Goi&aacute;s";
      case "10": return "MA - Maranh&atilde;o";
      case "11": return "MG - Minas Gerais";
      case "12": return "MS - Mato Grosso do Sul";
      case "13": return "MT - Mato Grosso";
      case "14": return "PA - Par&aacute;";
      case "15": return "PB - Para&iacute;ba";
      case "16": return "PE - Pernanbuco";
      case "17": return "PI - Piau&iacute;";
      case "18": return "PR - Paran&aacute;";
      case "19": return "RJ - Rio de Janeiro";
      case "20": return "RN - Rio Grande do Norte";
      case "21": return "RO - Rond�nia";
      case "22": return "RR - Roraima";
      case "23": return "RS - Rio Grande do Sul";
      case "24": return "SC - Santa Catarina";
      case "25": return "SE - Sergipe";
      case "26": return "SP - S&atilde;o Paulo";
      case "27": return "TO - Tocantins";
      default: return "";
    }
  }

  public equals(arg: EUF): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EUF[] = [this.NONE,this.AC,this.AL,this.AM,this.AP,this.BA,this.CE,this.DF,this.ES,this.GO,this.MA,this.MG,this.MS,this.MT,this.PA,this.PB,this.PE,this.PI,this.PR,this.RJ,this.RN,this.RO,this.RR,this.RS,this.SC,this.SE,this.SP,this.TO];
}


export class EGenero {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EGenero = new EGenero("0");
  get NONE() {
    return EGenero.NONE;
  }

  static readonly MASCULINO: EGenero = new EGenero("1");
  get MASCULINO() {
    return EGenero.MASCULINO;
  }

  static readonly FEMININO: EGenero = new EGenero("2");
  get FEMININO() {
    return EGenero.FEMININO;
  }

  static readonly UNISEX: EGenero = new EGenero("3");
  get UNISEX() {
    return EGenero.UNISEX;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Masculino";
      case "2": return "Feminino";
      case "3": return "UNISEX";
      default: return "";
    }
  }

  public equals(arg: EGenero): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EGenero[] = [this.NONE,this.MASCULINO,this.FEMININO,this.UNISEX];
}


export class ETipoPeriodo {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoPeriodo = new ETipoPeriodo("0");
  get NONE() {
    return ETipoPeriodo.NONE;
  }

  static readonly ANTERIOR: ETipoPeriodo = new ETipoPeriodo("1");
  get ANTERIOR() {
    return ETipoPeriodo.ANTERIOR;
  }

  static readonly COMPLETO: ETipoPeriodo = new ETipoPeriodo("2");
  get COMPLETO() {
    return ETipoPeriodo.COMPLETO;
  }

  static readonly POSTERIOR: ETipoPeriodo = new ETipoPeriodo("3");
  get POSTERIOR() {
    return ETipoPeriodo.POSTERIOR;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Personalizado";
      case "1": return "Anterior";
      case "2": return "Completo";
      case "3": return "Posterior";
      default: return "";
    }
  }

  public equals(arg: ETipoPeriodo): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoPeriodo[] = [this.NONE,this.ANTERIOR,this.COMPLETO,this.POSTERIOR];
}


export class EStatusPedidoSite {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusPedidoSite = new EStatusPedidoSite("0");
  get NONE() {
    return EStatusPedidoSite.NONE;
  }

  static readonly PRECONFPAGTO: EStatusPedidoSite = new EStatusPedidoSite("7");
  get PRECONFPAGTO() {
    return EStatusPedidoSite.PRECONFPAGTO;
  }

  static readonly CONFERENCIAPAGTO: EStatusPedidoSite = new EStatusPedidoSite("1");
  get CONFERENCIAPAGTO() {
    return EStatusPedidoSite.CONFERENCIAPAGTO;
  }

  static readonly EMANALISE: EStatusPedidoSite = new EStatusPedidoSite("10");
  get EMANALISE() {
    return EStatusPedidoSite.EMANALISE;
  }

  static readonly APROVADO: EStatusPedidoSite = new EStatusPedidoSite("6");
  get APROVADO() {
    return EStatusPedidoSite.APROVADO;
  }

  static readonly REPROVADO: EStatusPedidoSite = new EStatusPedidoSite("8");
  get REPROVADO() {
    return EStatusPedidoSite.REPROVADO;
  }

  static readonly EXPEDICAO: EStatusPedidoSite = new EStatusPedidoSite("2");
  get EXPEDICAO() {
    return EStatusPedidoSite.EXPEDICAO;
  }

  static readonly EMBARQUE: EStatusPedidoSite = new EStatusPedidoSite("3");
  get EMBARQUE() {
    return EStatusPedidoSite.EMBARQUE;
  }

  static readonly ENTREGUE: EStatusPedidoSite = new EStatusPedidoSite("4");
  get ENTREGUE() {
    return EStatusPedidoSite.ENTREGUE;
  }

  static readonly CANCELADO: EStatusPedidoSite = new EStatusPedidoSite("5");
  get CANCELADO() {
    return EStatusPedidoSite.CANCELADO;
  }

  static readonly DEVOLUCAO: EStatusPedidoSite = new EStatusPedidoSite("9");
  get DEVOLUCAO() {
    return EStatusPedidoSite.DEVOLUCAO;
  }

  static readonly CONTESTADO: EStatusPedidoSite = new EStatusPedidoSite("11");
  get CONTESTADO() {
    return EStatusPedidoSite.CONTESTADO;
  }

  static readonly NAOFINALIZADO: EStatusPedidoSite = new EStatusPedidoSite("12");
  get NAOFINALIZADO() {
    return EStatusPedidoSite.NAOFINALIZADO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "7": return "Pre confirmacao";
      case "1": return "Conf. pagto";
      case "10": return "Em analise";
      case "6": return "Aprovado";
      case "8": return "Reprovado";
      case "2": return "Expedicao";
      case "3": return "Embarque";
      case "4": return "Entregue";
      case "5": return "Cancelado";
      case "9": return "Devolucao";
      case "11": return "Contestado";
      case "12": return "Pedido nao Finalizado";
      default: return "";
    }
  }

  public equals(arg: EStatusPedidoSite): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPedidoSite[] = [this.NONE,this.PRECONFPAGTO,this.CONFERENCIAPAGTO,this.EMANALISE,this.APROVADO,this.REPROVADO,this.EXPEDICAO,this.EMBARQUE,this.ENTREGUE,this.CANCELADO,this.DEVOLUCAO,this.CONTESTADO,this.NAOFINALIZADO];
}


export class DataCEP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataCEP";
  cidade: string = "";
  bairro: string = "";
  codCEP: number = 0;
  codIbgeMun: string = "";
  codUF: string = "";
  logradouro: string = "";

  public getPK(): PK {
    let result: PK =  new PK();
    result.codigo = this.codCEP;
    return result;
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codCEP)
    ;
  }
}


export class BaseDataLogin extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataLogin";
  dataRef: string = "";
  codEmpresa: number = 0;
  codUsuario: BaseData = new BaseData();
}


export class ERamoAtividade {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ERamoAtividade = new ERamoAtividade("0");
  get NONE() {
    return ERamoAtividade.NONE;
  }

  static readonly CALCADO_CONFECCAO: ERamoAtividade = new ERamoAtividade("1");
  get CALCADO_CONFECCAO() {
    return ERamoAtividade.CALCADO_CONFECCAO;
  }

  static readonly ELETRO_MOVEIS: ERamoAtividade = new ERamoAtividade("2");
  get ELETRO_MOVEIS() {
    return ERamoAtividade.ELETRO_MOVEIS;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Cal&ccedil;ado Confec&ccedil;&atilde;o";
      case "2": return "El&eacute;tro M&oacute;veis";
      default: return "";
    }
  }

  public equals(arg: ERamoAtividade): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ERamoAtividade[] = [this.NONE,this.CALCADO_CONFECCAO,this.ELETRO_MOVEIS];
}


export class ETipoCST51SPED {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly REDUCAO_BASE: ETipoCST51SPED = new ETipoCST51SPED("0");
  get REDUCAO_BASE() {
    return ETipoCST51SPED.REDUCAO_BASE;
  }

  static readonly NORMAL: ETipoCST51SPED = new ETipoCST51SPED("1");
  get NORMAL() {
    return ETipoCST51SPED.NORMAL;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Informar o diferimento com base de calculo reduzida e CST 51";
      case "1": return "Informar o diferimento com a base de calculo cheia e CST 00";
      default: return "";
    }
  }

  public equals(arg: ETipoCST51SPED): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoCST51SPED[] = [this.REDUCAO_BASE,this.NORMAL];
}


export class PKFuncionarioGerencia extends PKFuncionario {
  readonly jclass: string = "com.sollus.vo.PKFuncionarioGerencia";
  codEmpresaGerencia: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number, codEmpresaGerencia: number)
  constructor(codEmpresa?: number, codFuncionario?: number, codEmpresaGerencia?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
    this.codEmpresaGerencia = codEmpresaGerencia || 0;
  }

  public getPK(): PKFuncionarioGerencia {
    return new PKFuncionarioGerencia(this.codEmpresa, this.codFuncionario, this.codEmpresaGerencia);
  }

  public equals(arg: PKFuncionarioGerencia): boolean {
    return arg && super.equals(arg)
        && (arg.codEmpresaGerencia === this.codEmpresaGerencia)
    ;
  }
}


export class DataPageContext extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataPageContext";
}


export class EPlanoVersaoLight {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EPlanoVersaoLight = new EPlanoVersaoLight("0");
  get NONE() {
    return EPlanoVersaoLight.NONE;
  }

  static readonly AUTONOMO: EPlanoVersaoLight = new EPlanoVersaoLight("1");
  get AUTONOMO() {
    return EPlanoVersaoLight.AUTONOMO;
  }

  static readonly BASICO: EPlanoVersaoLight = new EPlanoVersaoLight("2");
  get BASICO() {
    return EPlanoVersaoLight.BASICO;
  }

  static readonly IDEAL: EPlanoVersaoLight = new EPlanoVersaoLight("3");
  get IDEAL() {
    return EPlanoVersaoLight.IDEAL;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Autonomo";
      case "2": return "Basico";
      case "3": return "Ideal";
      default: return "";
    }
  }

  public equals(arg: EPlanoVersaoLight): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EPlanoVersaoLight[] = [this.NONE,this.AUTONOMO,this.BASICO,this.IDEAL];
}


export class DataArquivo extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataArquivo";
  path: string = "";
  nome: string = "";
  nomeEmDisco: string = "";
  extensao: string = "";
}


export class DataEnderecoComp extends DataEndereco {
  readonly jclass: string = "com.sollus.vo.DataEnderecoComp";
  descricaoEndereco: string = "";
  infReferencia: string = "";
  retirarLoja: boolean = false;
}


export class ETipoPagtoSite {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoPagtoSite = new ETipoPagtoSite("0");
  get NONE() {
    return ETipoPagtoSite.NONE;
  }

  static readonly PAGSYS: ETipoPagtoSite = new ETipoPagtoSite("1");
  get PAGSYS() {
    return ETipoPagtoSite.PAGSYS;
  }

  static readonly PAGSEGURO: ETipoPagtoSite = new ETipoPagtoSite("2");
  get PAGSEGURO() {
    return ETipoPagtoSite.PAGSEGURO;
  }

  static readonly CIELO: ETipoPagtoSite = new ETipoPagtoSite("3");
  get CIELO() {
    return ETipoPagtoSite.CIELO;
  }

  static readonly ITAU: ETipoPagtoSite = new ETipoPagtoSite("4");
  get ITAU() {
    return ETipoPagtoSite.ITAU;
  }

  static readonly REDECARD: ETipoPagtoSite = new ETipoPagtoSite("5");
  get REDECARD() {
    return ETipoPagtoSite.REDECARD;
  }

  static readonly MOOVIN: ETipoPagtoSite = new ETipoPagtoSite("6");
  get MOOVIN() {
    return ETipoPagtoSite.MOOVIN;
  }

  static readonly PAGAR_ME: ETipoPagtoSite = new ETipoPagtoSite("7");
  get PAGAR_ME() {
    return ETipoPagtoSite.PAGAR_ME;
  }

  static readonly CREDIARIO: ETipoPagtoSite = new ETipoPagtoSite("8");
  get CREDIARIO() {
    return ETipoPagtoSite.CREDIARIO;
  }

  static readonly CONDICIONAL: ETipoPagtoSite = new ETipoPagtoSite("9");
  get CONDICIONAL() {
    return ETipoPagtoSite.CONDICIONAL;
  }

  static readonly INTEGRACAO_WS: ETipoPagtoSite = new ETipoPagtoSite("10");
  get INTEGRACAO_WS() {
    return ETipoPagtoSite.INTEGRACAO_WS;
  }

  static readonly LOJA: ETipoPagtoSite = new ETipoPagtoSite("11");
  get LOJA() {
    return ETipoPagtoSite.LOJA;
  }

  static readonly MARKETPLACE: ETipoPagtoSite = new ETipoPagtoSite("12");
  get MARKETPLACE() {
    return ETipoPagtoSite.MARKETPLACE;
  }

  static readonly SITEF: ETipoPagtoSite = new ETipoPagtoSite("13");
  get SITEF() {
    return ETipoPagtoSite.SITEF;
  }

  static readonly ZOOP: ETipoPagtoSite = new ETipoPagtoSite("14");
  get ZOOP() {
    return ETipoPagtoSite.ZOOP;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pagsys";
      case "2": return "Pag Seguro";
      case "3": return "Cielo";
      case "4": return "Itau";
      case "5": return "Redecard";
      case "6": return "Moovin";
      case "7": return "Pagar.me";
      case "8": return "Credi&aacute;rio";
      case "9": return "Condicional";
      case "10": return "Integra&ccedil;&atilde;o WS";
      case "11": return "Loja";
      case "12": return "Marketplace";
      case "13": return "SiTEF";
      case "14": return "ZOOP";
      default: return "";
    }
  }

  public equals(arg: ETipoPagtoSite): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoPagtoSite[] = [this.NONE,this.PAGSYS,this.PAGSEGURO,this.CIELO,this.ITAU,this.REDECARD,this.MOOVIN,this.PAGAR_ME,this.CREDIARIO,this.CONDICIONAL,this.INTEGRACAO_WS,this.LOJA,this.MARKETPLACE,this.SITEF,this.ZOOP];
}


export class DataLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLOG";
  data: string = "";
  entidade: number = 0;
  acao: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  replicado: boolean = false;
  PKLog: string = "";
  hora: string = "";
  request: number = 0;
  codLOG: number = 0;
  base: number = 0;

  public getPK(): PKLong {
    let result: PKLong =  new PKLong();
    result.codigo = this.codLOG;
    return result;
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codLOG)
    ;
  }
}


export class PK extends BaseData {
  readonly jclass: string = "com.sollus.vo.PK";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PK {
    return new PK(this.codigo);
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class EFaixaEtaria {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EFaixaEtaria = new EFaixaEtaria("0");
  get NONE() {
    return EFaixaEtaria.NONE;
  }

  static readonly ADULTO: EFaixaEtaria = new EFaixaEtaria("1");
  get ADULTO() {
    return EFaixaEtaria.ADULTO;
  }

  static readonly INFANTIL: EFaixaEtaria = new EFaixaEtaria("2");
  get INFANTIL() {
    return EFaixaEtaria.INFANTIL;
  }

  static readonly BB: EFaixaEtaria = new EFaixaEtaria("3");
  get BB() {
    return EFaixaEtaria.BB;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Adulto";
      case "2": return "Infantil";
      case "3": return "Bebe";
      default: return "";
    }
  }

  public equals(arg: EFaixaEtaria): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EFaixaEtaria[] = [this.NONE,this.ADULTO,this.INFANTIL,this.BB];
}


export class ETipoPessoa {

  constructor(value?: string) {
    this.value = value || "";
  }

  static readonly NONE: ETipoPessoa = new ETipoPessoa("");
  get NONE() {
    return ETipoPessoa.NONE;
  }

  static readonly FISICA: ETipoPessoa = new ETipoPessoa("F");
  get FISICA() {
    return ETipoPessoa.FISICA;
  }

  static readonly JURIDICA: ETipoPessoa = new ETipoPessoa("J");
  get JURIDICA() {
    return ETipoPessoa.JURIDICA;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "": return "";
      case "F": return "F&iacute;sica";
      case "J": return "Jur&iacute;dica";
      default: return "";
    }
  }

  public equals(arg: ETipoPessoa): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoPessoa[] = [this.NONE,this.FISICA,this.JURIDICA];
}


export class ESexo {

  constructor(value?: string) {
    this.value = value || "NULL";
  }

  static readonly NONE: ESexo = new ESexo("NULL");
  get NONE() {
    return ESexo.NONE;
  }

  static readonly MASCULINO: ESexo = new ESexo("'M'");
  get MASCULINO() {
    return ESexo.MASCULINO;
  }

  static readonly FEMININO: ESexo = new ESexo("'F'");
  get FEMININO() {
    return ESexo.FEMININO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "NULL": return "";
      case "'M'": return "Masculino";
      case "'F'": return "Feminino";
      default: return "";
    }
  }

  public equals(arg: ESexo): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ESexo[] = [this.NONE,this.MASCULINO,this.FEMININO];
}


export class ERegimeTributario {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ERegimeTributario = new ERegimeTributario("0");
  get NONE() {
    return ERegimeTributario.NONE;
  }

  static readonly NORMAL: ERegimeTributario = new ERegimeTributario("3");
  get NORMAL() {
    return ERegimeTributario.NORMAL;
  }

  static readonly LUCRO_PRESUMIDO: ERegimeTributario = new ERegimeTributario("5");
  get LUCRO_PRESUMIDO() {
    return ERegimeTributario.LUCRO_PRESUMIDO;
  }

  static readonly SIMPLES_NACIONAL: ERegimeTributario = new ERegimeTributario("1");
  get SIMPLES_NACIONAL() {
    return ERegimeTributario.SIMPLES_NACIONAL;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "-- Informe --";
      case "3": return "Lucro Real";
      case "5": return "Lucro Presumido";
      case "1": return "Simples Nacional";
      default: return "";
    }
  }

  public equals(arg: ERegimeTributario): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ERegimeTributario[] = [this.NONE,this.NORMAL,this.LUCRO_PRESUMIDO,this.SIMPLES_NACIONAL];
}


export class EIndSincNFe {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly ASSINCRONO: EIndSincNFe = new EIndSincNFe("0");
  get ASSINCRONO() {
    return EIndSincNFe.ASSINCRONO;
  }

  static readonly SINCRONO: EIndSincNFe = new EIndSincNFe("1");
  get SINCRONO() {
    return EIndSincNFe.SINCRONO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Assincrono";
      case "1": return "Sincrono";
      default: return "";
    }
  }

  public equals(arg: EIndSincNFe): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EIndSincNFe[] = [this.ASSINCRONO,this.SINCRONO];
}


